export default __webpack_public_path__ + "a8ceb42f33075b31311e4c242b3f56eb.svg";